import { createFileRoute, redirect } from '@tanstack/react-router';

import { Organizations } from '@/features/organizations';

export const Route = createFileRoute('/_auth/organizations/')({
  beforeLoad: async ({ context: { auth, client } }) => {
    const { organizations } = await client.listOrganizations();

    if (organizations.length < 1) {
      throw redirect({ to: '/organizations/new', search: { onboarding: true } });
    } else if (organizations.length === 1) {
      const org = organizations[0];
      const orgCode = await auth.getCurrentOrganization();

      if (orgCode !== org.code) {
        throw redirect({ to: '/login', search: { orgCode: org.code } });
      } else {
        throw redirect({ to: '/' });
      }
    }
  },
  component: Organizations,
});
